module.exports = __webpack_public_path__ + "static/img/32.6afa5ed1.png";